<template>
    <b-modal id="modal_form"
            size="lg"
            ref="modal_form"
            :title="modal_titulo"
            :ok-title="modal_botao"
            close-title="Fechar"
            cancel-title="Cancelar"
            :ok-disabled=form.errors.any()
            v-model="showModal"
            @ok="handleOk">
    <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
        <b-container fluid class="p-a-0">
            <b-row>
                <b-col sm="6" md="2" class="p-l-0">
                    <label>Grade de Coleta</label>
                    <b-form-input
                        type="text"
                        placeholder="N° de dias para coleta"
                        v-model="form.qtde_dias_coleta"
                        name="descr">
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('qtde_dias_coleta')" v-if="form.errors.has('qtde_dias_coleta')"></b-form-feedback>
                </b-col>
                <b-col sm="6" md="2" class="p-l-0">
                    <label>Grade de Entrega</label>
                    <b-form-input
                        type="text"
                        placeholder="N° de dias para entrega"
                        v-model="form.qtde_dias_entrega"
                        name="horario_tz">
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('qtde_dias_entrega')" v-if="form.errors.has('qtde_dias_entrega')"></b-form-feedback>
                </b-col>
                <b-col sm="6" md="4" class="p-l-0">
                    <label>Tipo da Operação</label>
                    <multiselect v-model="tpOperacaoSelected"
                    :options="this.$parent.optionsTpOperacao"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                    ></multiselect>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('tp_operacao')" v-if="form.errors.has('tp_operacao')"></b-form-feedback>
                </b-col>
                <b-col sm="6" md="4" class="p-l-0">
                    <label>Transportadora</label>                        
                    <multiselect
                        v-model="transportadoraSelected"
                        :options-limit="300"
                        :limit="2"
                        :limit-text="limitText"
                        :options="optionsTransportadora"
                        track-by="value"
                        label="label"
                        id="transportadora"
                        :hide-selected="true"
                        placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                        :searchable="true"
                        :loading="isLoadingTransportadora"
                        @search-change="listaTransportadora"
                        ></multiselect>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('transportadora')" v-if="form.errors.has('transportadora')"></b-form-feedback>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="p-l-0">
                    <label></label>
                    <multiselect v-model="municipioIniSelected"
                    :options="this.$parent.optionsMunicipio"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Municipio Origem"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                    ></multiselect>
                    <b-form-feedback v-text="form.errors.get('municipio_id_ini')" v-if="form.errors.has('municipio_id_ini')"></b-form-feedback>
                </b-col>
                <b-col class="p-l-0">
                    <label></label>
                    <multiselect v-model="municipioFimSelected"
                    :options="this.$parent.optionsMunicipio"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Municipio Destino"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                    ></multiselect>
                    <b-form-feedback v-text="form.errors.get('municipio_id_fim')" v-if="form.errors.has('municipio_id_fim')"></b-form-feedback>
                </b-col>
                <b-col class="p-l-0">
                    <label></label>
                    <multiselect v-model="regiaoIniSelected"
                    :options="this.$parent.optionsRegiao"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Região Origem"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                    ></multiselect>
                    <b-form-feedback v-text="form.errors.get('regiao_id_ini')" v-if="form.errors.has('regiao_id_ini')"></b-form-feedback>
                </b-col>
                <b-col class="p-l-0">
                    <label></label>
                    <multiselect v-model="regiaoFimSelected"
                    :options="this.$parent.optionsRegiao"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Região Destino"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                    ></multiselect>
                    <b-form-feedback v-text="form.errors.get('regiao_id_fim')" v-if="form.errors.has('regiao_id_fim')"></b-form-feedback>
                </b-col>
            </b-row>
            <hr class="p-a-0 m-t m-b-0">
            <div class="tbl-row p-a-0">
                <div class="tbl-cell tbl-cell-title">
                    <h5 class="m-a-0">Grade de Coleta</h5>
                </div>
            </div>
            <b-row>
                <b-col style="display:flex">
                    <label>Segunda-Feira: </label>
                    <b-form-checkbox v-model="form.coleta_segunda"
                                        value="1"
                                        unchecked-value="2">
                    </b-form-checkbox>
                </b-col>
                <b-col style="display:flex">
                    <label>Terça-Feira: </label>
                    <b-form-checkbox v-model="form.coleta_terca"
                                        value="1"
                                        unchecked-value="2">
                    </b-form-checkbox>
                </b-col>
                <b-col style="display:flex">
                    <label>Quarta-Feira: </label>
                    <b-form-checkbox v-model="form.coleta_quarta"
                                        value="1"
                                        unchecked-value="2">
                    </b-form-checkbox>
                </b-col>
                <b-col style="display:flex">
                    <label>Quinta-Feira: </label>
                    <b-form-checkbox v-model="form.coleta_quinta"
                                        value="1"
                                        unchecked-value="2">
                    </b-form-checkbox>
                </b-col>
                <b-col style="display:flex">
                    <label>Sexta-Feira: </label>
                    <b-form-checkbox v-model="form.coleta_sexta"
                                        value="1"
                                        unchecked-value="2">
                    </b-form-checkbox>
                </b-col>
                <b-col style="display:flex">
                    <label>Sabado: </label>
                    <b-form-checkbox v-model="form.coleta_sabado"
                                        value="1"
                                        unchecked-value="2">
                    </b-form-checkbox>
                </b-col>
                <b-col style="display:flex">
                    <label>Domingo: </label>
                    <b-form-checkbox v-model="form.coleta_domingo"
                                        value="1"
                                        unchecked-value="2">
                    </b-form-checkbox>
                </b-col>
                <b-col style="display:flex">
                    <label>Dias Uteis: </label>
                    <b-form-checkbox v-model="form.coleta_dias_uteis"
                                        value="1"
                                        unchecked-value="2">
                    </b-form-checkbox>
                </b-col>
            </b-row>
            <hr class="p-a-0 m-t m-b-0">
            <div class="tbl-row p-a-0">
                <div class="tbl-cell tbl-cell-title">
                    <h5 class="m-a-0">Grade de Entrega</h5>
                </div>
            </div>
            <b-row>
                <b-col style="display:flex">
                    <label>Segunda-Feira: </label>
                    <b-form-checkbox v-model="form.entrega_segunda"
                                        value="1"
                                        unchecked-value="2">
                    </b-form-checkbox>
                </b-col>
                <b-col style="display:flex">
                    <label>Terça-Feira: </label>
                    <b-form-checkbox v-model="form.entrega_terca"
                                        value="1"
                                        unchecked-value="2">
                    </b-form-checkbox>
                </b-col>
                <b-col style="display:flex">
                    <label>Quarta-Feira: </label>
                    <b-form-checkbox v-model="form.entrega_quarta"
                                        value="1"
                                        unchecked-value="2">
                    </b-form-checkbox>
                </b-col>
                <b-col style="display:flex">
                    <label>Quinta-Feira: </label>
                    <b-form-checkbox v-model="form.entrega_quinta"
                                        value="1"
                                        unchecked-value="2">
                    </b-form-checkbox>
                </b-col>
                <b-col style="display:flex">
                    <label>Sexta-Feira: </label>
                    <b-form-checkbox v-model="form.entrega_sexta"
                                        value="1"
                                        unchecked-value="2">
                    </b-form-checkbox>
                </b-col>
                <b-col style="display:flex">
                    <label>Sabado: </label>
                    <b-form-checkbox v-model="form.entrega_sabado"
                                        value="1"
                                        unchecked-value="2">
                    </b-form-checkbox>
                </b-col>
                <b-col style="display:flex">
                    <label>Domingo: </label>
                    <b-form-checkbox v-model="form.entrega_domingo"
                                        value="1"
                                        unchecked-value="2">
                    </b-form-checkbox>
                </b-col>
                <b-col style="display:flex">
                    <label>Dias Uteis: </label>
                    <b-form-checkbox v-model="form.entrega_dias_uteis"
                                        value="1"
                                        unchecked-value="2">
                    </b-form-checkbox>
                </b-col>
            </b-row>
        </b-container>
    </form>
    <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
                <b-btn @click="showModal=false" variant="secondary">
                    Fechar
                </b-btn>
                <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                    Enviar
                </b-btn>
            </div>
    </div>
</b-modal>
</template>
<script>
import AvisoErros from '../components/AvisoErros'
import moment from 'moment'

export default {
components: {
    AvisoErros,
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
        modal_titulo: '',
        modal_botao: '',
        modal_acao: '',
        loading: false,
        isDisabled: false,
        loadingData: true,
        showModal: false,
        showModalGrupo: false,
        isFullscreen: false,
        errors_array: [],
        reg_destinho:'',
        isLoadingTransportadora: false,
        optionsTransportadora: [],
        transportadoraSelected: [],
        municipioIniSelected: [],
        municipioFimSelected: [],
        regiaoIniSelected: [],
        regiaoFimSelected: [],
        tpOperacaoSelected: [],
        optionsDaysOptions: [
            {text: 'Sim', value: '1'},
            {text: 'Não', value: '2'},
        ],
        helpForm: new Form({
            statusRecord: [],
            params: [],
            search: ''
        }),
        form: new Form({
            cd: '',
            gracolent_id: '',
            tp_operacao: '',
            qtde_dias_coleta: '',
            qtde_dias_entrega: '',
            municipio_id_ini: '',
            municipio_id_fim: '',
            regiao_id_ini: '',
            regiao_id_fim: '',
            pessoa_id: '',
            coleta_dias_uteis: "2",
            entrega_dias_uteis: "2",
            coleta_segunda: "2",
            coleta_terca: "2",
            coleta_quarta: "2",
            coleta_quinta: "2",
            coleta_sexta: "2",
            coleta_sabado: "2",
            coleta_domingo: "2",
            entrega_segunda: "2",
            entrega_terca: "2",
            entrega_quarta: "2",
            entrega_quinta: "2",
            entrega_sexta: "2",
            entrega_sabado: "2",
            entrega_domingo: "2",
        }),
        fields: [],
      css: {
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
      },
      moreParams: {}
   }
},
watch: {
    municipioIniSelected(obj){
        this.form.municipio_id_ini = obj.value;
    },
    municipioFimSelected(obj){
        this.form.municipio_id_fim = obj.value;
    },
    regiaoIniSelected(obj){
        this.form.regiao_id_ini = obj.value;
    },
    regiaoFimSelected(obj){
        this.form.regiao_id_fim = obj.value;
    },
    transportadoraSelected(obj){
        this.form.pessoa_id = obj.value;
    },
    tpOperacaoSelected(obj){
        this.form.tp_operacao = obj.value;
    }
},
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.gracolent_id);
        }
    },
    onCreate() {
        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Cadastrar";
        this.modal_botao = "Cadastrar";
        this.modal_acao = "i";
        this.form.reset();
        this.form.coleta_dias_uteis = 2;
        this.form.coleta_segunda = 2;
        this.form.coleta_terca = 2;
        this.form.coleta_quarta = 2;
        this.form.coleta_quinta = 2;
        this.form.coleta_sexta = 2;
        this.form.coleta_sabado = 2;
        this.form.coleta_domingo = 2;
        this.form.entrega_dias_uteis = 2;
        this.form.entrega_segunda = 2;
        this.form.entrega_terca = 2;
        this.form.entrega_quarta = 2;
        this.form.entrega_quinta = 2;
        this.form.entrega_sexta = 2;
        this.form.entrega_sabado = 2;
        this.form.entrega_domingo = 2;
        this.errors_array= [],
        this.municipioIniSelected = [];
        this.municipioFimSelected = [];
        this.regiaoIniSelected = [];
        this.regiaoFimSelected = [];
        this.transportadoraSelected = [];
        this.tpOperacaoSelected = [];
        this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
        console.log(data);
        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Alterar";
        this.modal_botao = "Alterar";
        this.modal_acao = "u";
        this.form.reset();
        this.form.gracolent_id = data.gracolent_id;
        this.municipioIniSelected = [];
        this.municipioFimSelected = [];
        this.regiaoIniSelected = [];
        this.errors_array= [],
        this.regiaoFimSelected = [];
        this.tpOperacaoSelected = [];
        this.transportadoraSelected = [];
        this.form.coleta_dias_uteis = data.coleta_dias_uteis.valor;
        this.form.coleta_segunda = data.coleta_segunda.valor;
        this.form.coleta_terca = data.coleta_terca.valor;
        this.form.coleta_quarta = data.coleta_quarta.valor;
        this.form.coleta_quinta = data.coleta_quinta.valor;
        this.form.coleta_sexta = data.coleta_sexta.valor;
        this.form.coleta_sabado = data.coleta_sabado.valor;
        this.form.coleta_domingo = data.coleta_domingo.valor;
        this.form.entrega_dias_uteis = data.entrega_dias_uteis.valor;
        this.form.entrega_segunda = data.entrega_segunda.valor;
        this.form.entrega_terca = data.entrega_terca.valor;
        this.form.entrega_quarta = data.entrega_quarta.valor;
        this.form.entrega_quinta = data.entrega_quinta.valor;
        this.form.entrega_sexta = data.entrega_sexta.valor;
        this.form.entrega_sabado = data.entrega_sabado.valor;
        this.form.entrega_domingo = data.entrega_domingo .valor;

        this.form.qtde_dias_coleta = data.qtde_dias_coleta;
        this.form.qtde_dias_entrega = data.qtde_dias_entrega;
        this.tpOperacaoSelected = {label: data.tp_operacao.descr, value:data.tp_operacao.valor};
        if(data.pessoa != null){
            this.transportadoraSelected = {label: data.pessoa.pessoa_juridica.razao_social, value:data.pessoa.pessoa_juridica.pessoa_id};
        }

        if(data.municipio_ini != null){
            this.municipioIniSelected = {label: data.municipio_ini.nome, value: data.municipio_ini.municipio_id}
        }
        if(data.municipio_fim != null){
            this.municipioFimSelected = {label: data.municipio_fim.nome, value: data.municipio_fim.municipio_id}
            console.log('in')
        }
        if(data.regiao_ini != null){
            this.regiaoIniSelected = {label: data.regiao_ini.descr, value: data.regiao_ini.regiao_id}
        }
        if(data.regiao_fim != null){
            this.regiaoFimSelected = {label: data.regiao_fim.descr, value: data.regiao_fim.regiao_id}
        }
        this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/gradecoletaentrega/store').then(response =>
        {
            new ReturnApi(response, this)
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/gradecoletaentrega/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });
    },
    formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
      return (value == null || value == "")
      ? ''
      : moment(value, 'YYYY-MM-DD HH:mm').format(fmt)
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/gradecoletaentrega/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this, true, null, null, false);
            this.errors_array = '';
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof(errors[property]) === 'object') {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj
                    });
                  });
                }
              }
            }
        });

    },
    listaTransportadora(search) {
        if (search.length >= 3) {
            this.isLoadingTransportadora = true;
            this.helpForm.search = search;
            this.helpForm.status = 1;
            this.helpForm
            .post("/api/pessoa/jsonlist/transportadora")
            .then((response) => {
                this.optionsTransportadora = [];
                new ReturnApi(response, this, true, false, false);
                if (response.items.length > 0) {
                response.items.forEach((obj) => {
                    this.optionsTransportadora.push({
                    label: "PJ -" + obj.pessoa.cd + " - " + obj.razao_social + " - " + this.onFormataCnpj( obj.cnpj_base, obj.cnpj_filial, obj.cnpj_digito).replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") + " - " + obj.inscricao_estadual, pessoa_id: obj.pessoa_id, value: obj.pessoa_id,
                    });
                });
                }
                if (response.itemsF.length > 0) {
                response.itemsF.forEach((obj) => {
                    this.optionsTransportadora.push({
                    label: "PF -" + obj.nome + " - " + obj.cpf,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                    });
                });
                }
                if (response.itemsE.length > 0) {
                response.itemsE.forEach((obj) => {
                    this.optionsTransportadora.push({
                    label: "PE -" + obj.nome + " - " + obj.cd,
                    pessoa_id: obj.pessoa_id,
                    value: obj.pessoa_id,
                    });
                });
                }
                this.isLoadingTransportadora = false;
            })
            .catch((errors) => {
                new ReturnApi(errors, this);
            });
        }
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
        var cnpj_formatado
        var pad = "00000000";
        var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
        var pad = "0000"
        var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
        var pad = "00"
        var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;
        return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    getCurrency: {
        get() {
            return this.$store.getters.currency;
        }
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
<style>
    label{
        margin-right: 5px;
    }
</style>